import selector from 'modules/Auth/selectors.js'
import ErrorMessage from 'utils/ErrorMessage'
import corporateRequest from 'utils/corporateRequest'
import studentRequest from 'utils/studentRequest'
import instituteRequest from 'utils/instRequest'
export const SET_JOB_ROLE_PREVIEW_DATA = 'corporate/GET_JOB_ROLE_PREVIEW_DATA'
export const SET_CANDIDATE_LIST_DATA = 'student/GET_CANDIDATE_LIST_DATA'
export const SET_CANDIDATE_METRICS_DATA = 'student/GET_CANDIDATE_METRICS_DATA'
const setJobRolePreviewData = data => {
  return {
    type: SET_JOB_ROLE_PREVIEW_DATA,
    data,
  }
}
const setCandidateListData = data => {
  return {
    type: SET_CANDIDATE_LIST_DATA,
    data,
  }
}

const setMetricsData = data => {
  return {
    type: SET_CANDIDATE_METRICS_DATA,
    data,
  }
}

export const getJobRolePreview = roleId => async (dispatch, getState) => {
  try {
    const response = await corporateRequest.get(`/corporates/jobs/${roleId}`)
    if (response.status === 200) {
      dispatch(setJobRolePreviewData(response?.data?.data))
    }
    return response
  } catch (err) {}
}

export const getJobRoleCandidateList =
  (roleId, pageNo, pageLimit, status, keyword, setIsLoading) =>
  async (dispatch, getState) => {
    try {
      setIsLoading(true)

      const state = getState()
      const instituteCampusId = selector.getInstituteDetails(state)?.id
      const response = await studentRequest.get(
        `students/role/${roleId}/instituteCampus/${instituteCampusId}/candidate/list?pageNo=${pageNo}&pageLimit=${pageLimit}&search=${keyword}&status=${status}`
      )
      if (response.status === 200) {
        dispatch(setCandidateListData(response?.data?.data))
      }
      setIsLoading(false)
      return response
    } catch (err) {}
  }
  export const getJobRoleCandidateAppliedList =
  (roleId) =>
  async (dispatch, getState) => {
    try {
      let pageNo = 0;
      let pageLimit = 2500;
      let status = 'APPLIED'
      const state = getState()
      const instituteCampusId = selector.getInstituteDetails(state)?.id
      const response = await studentRequest.get(
        `students/role/${roleId}/instituteCampus/${instituteCampusId}/candidate/list?pageNo=${pageNo}&pageLimit=${pageLimit}&status=${status}`
      )
   
      return response
    } catch (err) {}
  }
export const getCandidateMetrics = roleId => async (dispatch, getState) => {
  try {
    const state = getState()
    const instituteCampusId = selector.getInstituteDetails(state)?.id
    const response = await studentRequest.get(
      `students/role/${roleId}/instituteCampus/${instituteCampusId}/candidate/metrics`
    )
    if (response.status === 200) {
      dispatch(setMetricsData(response?.data?.data))
    }
    return response
  } catch (err) {}
}
export const CloseRole =
  (corporateId, jobId, payload) => async (dispatch, getState) => {
    try {
      const result = await corporateRequest.post(
        `/corporates/${corporateId}/jobs/${jobId}/close`,
        payload
      )
      return result
    } catch (error) {
      ErrorMessage(error?.response?.data?.message)
    }
  }

export const getPlacementHistoryList =
  (studentId, pageNo, pageLimit, status, evaluationStatus, jobCategory) =>
  async (dispatch, getState) => {
    const evaluationStatusParams =
      evaluationStatus && `&evaluationStatus=${evaluationStatus}`
    const jobCategoryParams = jobCategory && `&jobCategory=${jobCategory === 'INTERNSHIP_PPO' ? 'INTERNSHIP%2BPPO' : jobCategory}`
    const statusParams = `&status=${status}`

    try {
      const response = await corporateRequest.get(
        `corporates/student/${studentId}/mappedJobs/lists?pageNo=${pageNo}&pageLimit=${pageLimit}${statusParams}${evaluationStatusParams}${jobCategoryParams}`
      )
      return response
    } catch (err) {}
  }

export const getStudentPlacedList =
  (studentId, pageNo, pageLimit) => async (dispatch, getState) => {
    try {
      const response = await corporateRequest.get(
        `corporates/placementList/student/${studentId}?pageNo=${pageNo}&pageLimit=${pageLimit}`
      )
      return response
    } catch (err) {}
  }

  export const getOneRoleExports = (payload) => async (dispatch, getState) => {
    try {
      const config = payload.downloadType !== 'googlesheet' ? { responseType: 'blob' } : {}
      const state = getState()
      const instituteCampusId = selector.getInstituteDetails(state)?.id
      const response = await instituteRequest.post(`/instituteReport/instituteCampusId/${instituteCampusId}/export/role_wise_report`,
        payload,
        config
      )
      if (response.status === 200) {
        return response?.data
      }
    } catch (err) {}
  }

  export const duplicateRole =
  (jobId, corporate_id, instituteCampusId) => async () => {
    try {
      const result = await corporateRequest.post(
        `/corporates/${corporate_id}/jobs/${jobId}/duplicate`,
        { instituteCampusId: instituteCampusId }
      )
      return result
    } catch (error) {
      ErrorMessage(error?.message)
    }
  }

  export const completeRole =
  (jobId, instituteCampusId) => async () => {
    try {
      const result = await corporateRequest.put(
        `/corporate/institute/${instituteCampusId}/${jobId}/complete`,
        {
          status: "COMPLETED"
        }
      )
      return result
    } catch (error) {
      ErrorMessage(error?.message)
    }
  }

  export const getSingleRoleDetails =
  (JobID,studentId) => async (dispatch, getState) => {
    try {
      const res = await corporateRequest.get(
        `/corporate/role/${JobID}/${studentId}`
      )
      return res?.data?.data
    } catch (error) {
      console.log('Error in Getting Jobs list', error)
    }
  }